import React,{useEffect} from 'react';
import * as S from './Category.styles'
import classnames from 'classnames';
export const Category = ({data,categoryId,updateCategoryId})=>{
    if(!data || !Array.isArray(data)){
        return null;
    }
  useEffect(()=>{
    if(!categoryId){
        updateCategoryId(data?.[0]?.id)

    }
  },[])
    return (
        <S.SelectCategory>
        <h3>Select Category</h3>

        <ul className="categoryOptions">
            {data?.map(({id,primaryText='',icon={},image={}},index)=>{
                return(
                    <li className="categoryOption" key={`categoryOptions${index}`}>
                <input type="radio"
                    id={id}
                    name="category"
                    value={primaryText}
                    checked={categoryId === id ||  (!categoryId && !index ? true :false)}
                    onChange={(e)=>{
                        updateCategoryId(e?.target?.id)
                    }}
                />
                <label htmlFor="flights">
                    <span className={classnames(icon?.iconClasses)}></span>{primaryText}</label>
            </li>
                )
            })}
            

         

        </ul>
    </S.SelectCategory>
    )
}